#import "../fragments/form-fragment.graphql"

mutation DuplicateForm($input: FormDuplicateInputFieldInput!) {
    formDuplicate(input: $input) {
        form {
            ...FormFragment
        }
    }
}
